import React from 'react';
import { createPortal } from 'react-dom';
import menuLinkClickStatsigTrack from 'src/functions/menuClickLinkStatsigTrack';
import { useExpandedMenuController } from 'src/hooks/useExpandedMenuController';
import Button from 'atoms/Button/Button';
import { IMenuLink } from 'src/app/molecules/Header/Header/HeaderLinks';
import { cssVar } from 'src/app/styles/helper';
import { ChevronIcon } from './HeaderMenuLink.styles';

interface HeaderMenuLinkProps extends IMenuLink {
  locationPathname: string;
}

const HeaderMenuLink = (props: HeaderMenuLinkProps): JSX.Element => {
  const { text, href, trackingSlug, locationPathname } = props;
  const { currentExpanded, toggleExpandedMenu } = useExpandedMenuController();

  const expandableMenuOpen = currentExpanded === text;
  const isActivePath = locationPathname === href;

  const trackLinkOnCLick = () => {
    menuLinkClickStatsigTrack(trackingSlug);
    return true; // To proceed with anchor link event
  };

  const onExpandableMenuToggle = () => {
    if (!expandableMenuOpen) {
      // Track only opening the expandable menu
      trackLinkOnCLick();
    }

    toggleExpandedMenu(props.text);
  };

  const onExpandableMenuClose = () => {
    toggleExpandedMenu(props.text, false);
  };

  if (props.useExpandableMenu && props.expandableMenu) {
    const expandableRenderTarget = typeof document !== 'undefined' ? document.getElementById('header') : null;
    return (
      <>
        <Button
          variant='tertiary'
          size='sm'
          iconPosition='right'
          className={`header-menu-link ${isActivePath ? 'active' : ''} ${expandableMenuOpen ? 'expanded' : ''}`}
          onClick={onExpandableMenuToggle}
          icon={
            <ChevronIcon
              width={20}
              orientation={expandableMenuOpen ? 'up' : 'down'}
              color={cssVar('fg-quaternary')}
            />
          }
        >
          {text}
        </Button>
        {expandableRenderTarget &&
          createPortal(
            <props.expandableMenu
              onClose={onExpandableMenuClose}
              isOpen={expandableMenuOpen}
            />,
            expandableRenderTarget
          )}
      </>
    );
  }

  return (
    <Button
      variant='tertiary'
      href={href}
      size='sm'
      className={`header-menu-link ${isActivePath ? 'active' : ''}`}
      onClick={trackLinkOnCLick}
    >
      {text}
    </Button>
  );
};

export default HeaderMenuLink;
